import { createRoute } from "@tanstack/react-router";
import { requirePermissions } from "@/app/guards";
import { PROGRAMS_PERMISSIONS } from "@/app/nav";
import { ProgramDetailPage } from "@/features/programs/ProgramDetailPage";
import { ProgramList } from "@/features/programs/ProgramList";
import { staffRoute } from "@/routes/staff";

export const programsRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "programs",
  beforeLoad: ({ context }) => requirePermissions(context.session, PROGRAMS_PERMISSIONS),
  component: ProgramList,
});

export const programDetailRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "programs/$programId",
  beforeLoad: ({ context }) => requirePermissions(context.session, PROGRAMS_PERMISSIONS),
  component: ProgramDetailPage,
});
